import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7978a98d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-imput-base" }
const _hoisted_2 = ["value", "type"]
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      value: _ctx.value != undefined ? _ctx.value : _ctx.modelValue,
      type: _ctx.type,
      class: _normalizeClass(_ctx.classIn + ' ss-input' + (_ctx.icon != undefined ? (_ctx.icon.length <= 0 ?  ' wicon' : ' wficon') : '')),
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.getValue($event.target))))
    }, null, 42, _hoisted_2),
    (_ctx.icon != undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.icon.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 1,
                icon: _ctx.icon
              }, null, 8, ["icon"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}